import { render, staticRenderFns } from "./NoActive.vue?vue&type=template&id=9ef560cc&scoped=true&lang=pug&"
var script = {}
import style0 from "./NoActive.vue?vue&type=style&index=0&id=9ef560cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef560cc",
  null
  
)

export default component.exports